import { createAction } from 'typesafe-actions';
import { Alert } from '../../types/alert';

export const createAlert = createAction('ALERT_CREATE', action => (alert: Alert) => action(alert));
export const removeAlert = createAction('ALERT_REMOVE', action => (id: string) => action(id));
